<template>
  <!-- <v-card :loading="isUpdating"> -->
  <v-form>
    <v-container>
      <v-row>
        <v-col>
          <!-- :items="people" -->
          <v-autocomplete
            v-model="admins"
            :disabled="isUpdating"
            background-color="white"
            item-text="name"
            item-value="_id"
            outlined
            dense
            multiple
            :items="people"
            append-icon="mdi-menu-down mt-3"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="data.parent.selectItem(data.item)"
                label
                class="my-1 mr-1"
              >
                <v-avatar left>
                  <v-img :src="data.item.avatar"></v-img>
                </v-avatar>
                {{ data.item.name }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-avatar>
                  <img :src="data.item.avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.name"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="data.item.group"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
  <!-- </v-card> -->
</template>
<script>
import { getUserList } from '@/service/account/manageUser';
export default {
  props: ['updateAdmins', 'admins'],
  data() {
    return {
      userForAdminSelector: [],
      autoUpdate: true,
      friends: [],
      isUpdating: false,
      name: 'Midnight Crew',
      people: [],
      title: 'The summer breeze',
    };
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
    admins(newFriends) {
      this.updateAdmins(newFriends);
    },
  },
  methods: {
    remove(item) {
      const index = this.friends.indexOf(item._id);
      if (index >= 0) this.friends.splice(index, 1);
    },
  },
  async mounted() {
    this.friends = this.admins;
    const teachers = await getUserList({ isTeacher: 'y' });
    const newPeople = teachers.data.map((u) => {
      return {
        name: `${u.firstName} ${u.lastName}`,
        avatar: u.image,
        _id: u._id,
      };
    });
    this.people = newPeople;
  },
};
</script>
